import React from "react";
import { Form } from "react-bootstrap";

class TextArea extends React.Component {
  validateAndChange = (e, fieldName, callback) => {
    let isValid = true;

    const {
      isAlphaNumeric = false,
      isSpecialAlphaNumeric = false,
      required=false
    } = this.props;

    if (isAlphaNumeric && e.target.value !== "") {
      let isAlphaNumeric =
        /^(?=.*[a-zA-Z])( ?[A-Za-z0-9 , . ! $ % & -] ?)+$/.test(e.target.value);
      if (!isAlphaNumeric) {
        isValid = false;
      }
    }

    if (isSpecialAlphaNumeric && e.target.value !== "") {
      let isSpecialAlphaNumeric =
        /^(?=.*[a-zA-Z])( ?[A-Za-z0-9 , . ! $ % & - ( )] ?)+$/.test(e.target.value);
      if (!isSpecialAlphaNumeric) {
        isValid = false;
      }
    }

    /*if (isEmail) {
      let isEmail = /^\w+([\.+-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(
        e.target.value
      );
      if (!isEmail) {
        isValid = false;
      }
    }*/

    if (isValid) {
      callback(e, fieldName);
    }
  };

  onBlurChange = (e, fieldName, callback) => {
    let isValid = true;

    if (isValid) {
      callback(e, fieldName);
    }
  };

  renderComponent = () => {
    const { name, action, value, placeholder, rows,required,maxLength=50, disabled=false, className } = this.props;
    return (
      <div>
        <Form.Control
          as="textarea"
          rows={rows}
          placeholder={placeholder}
          name={name}
          value={value}
          onChange={(e) => this.validateAndChange(e, name, action)}
          required={required}
          maxLength={maxLength}
          disabled={disabled}
          className={className}
        />
      </div>
    );
  };

  render() {
    return this.renderComponent();
  }
}
export default TextArea;
